<template>
  <div class="cmp-redirect">
    <h2>Redirecting to a valid route...</h2>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">

</style>